import React, { useState } from 'react';
import { Typography, Grid, Container, Button, Box, CardMedia, Divider, Badge, Stack } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useDispatch } from 'react-redux';
import { setContactUs } from 'api/session';

const Block1a = (props) => {
    const [eli, setEli] = useState(2);
    const dispatch = useDispatch();
    const hoverChange = (params) => {
        if (params === 'in') {
            setEli(2)
        } else {
            setEli(1)
        }
    }
    const trademarkSymbol = '\u2122';
    const mdSize = useMediaQuery((theme) => theme.breakpoints.only('md'));
    return (
        <Container
            direction="row"
            disableGutters
            maxWidth={'xl'}
            sx={{
                marginTop: "40px"
            }}
        >
            <Divider sx={{ margin: "25px" }} />
            <Grid container item md={12} justifyContent={'center'} direction={'row'} alignItems={'flex-start'}>
                <Grid container item md={6}>
                    <Grid container item md={2} />
                    <Grid container item md={10} direction={'column'}
                        alignItems={{
                            xs: "center",
                            md: 'flex-start'
                        }}
                        justifyContent={'space-between'}>

                        <Button disableElevation variant='contained' size="large" sx={{ backgroundColor: "#FFEAE6", marginRight: "10px", color: "#FE753E", fontWeight: "bold", borderRadius: "50px" }}>Tirefax powered by AI</Button>
                        <Typography
                            variant={'h1'}
                            sx={{
                                fontSize: "32px",
                                fontWeight: "bold",
                                marginTop: "25px"
                            }}
                        >
                            Trust Tirefax the Tire Experts<sup style={{ fontSize: "18px" }}>{trademarkSymbol}</sup>
                        </Typography>
                        <Typography

                            sx={{
                                fontSize: "18px",
                                color: "#808291",
                                marginTop: "20px",
                                fontWeight: "normal",
                                textAlign: "justify",
                                padding: "10px"

                            }}
                        >
                            Trust only Tirefax, the go-to-expert in tires, tire safety and tire forensics for auto dealerships, auto service retailers, fleets, auction yards, rental agencies and in the reconditioning process.
                        </Typography>

                        <Stack
                            sx={{
                                width: "100%",
                                marginTop: "20px"
                            }}
                            direction="row"
                            justifyContent={{
                                xs: "center",
                                md: "space-between"
                            }}
                            alignItems={{
                                xs: "center",
                                md: 'flex-start'
                            }}


                        >
                            <Button onClick={() => dispatch(setContactUs(true))} disableElevation variant='contained' size="large" sx={{ padding: "20px", marginTop: "25px", backgroundColor: "#380e87", marginRight: "10px", color: "#fff", fontWeight: "bold", borderRadius: "50px" }}>REQUEST TIREFAX DEMO</Button>
                        </Stack>
                    </Grid>
                    <Grid container item md={1} />
                </Grid>

                <Grid container item md={6} justifyContent={'center'} direction={'column'} alignItems={'center'}>

                    <CardMedia
                        component="img"
                        width={"400"}
                        image={'/tire.jpg'}
                        sx={{
                            padding: "25px"
                        }}

                        onMouseOver={() => hoverChange('in')}
                        onMouseOut={() => hoverChange('out')}
                    />


                </Grid>
            </Grid>
        </Container>
    )
}

export default Block1a;